import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { CommonProperties, CommonStyles } from '../../../styles';
import { scale } from '../../../utils/scale.utils';
import BaseText from '../../BaseText';

const EventSelectorItem = ({ label, selected }) => {
  return (
    <View style={[styles.item, selected ? styles.itemSelected : styles.itemUnselected]}>
      <BaseText style={CommonStyles.h4}>{label}</BaseText>
    </View>
  );
};

const EventSelector = ({ days, selected, style, onChange }) => {
  return (
    <ScrollView style={[{ height: scale(34), flex: 1 }, style]} horizontal>
      {days &&
        days.map((day) => (
          <TouchableOpacity key={day.id} onPress={() => onChange(day)}>
            <EventSelectorItem label={day.label} selected={day.id === selected} />
          </TouchableOpacity>
        ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  item: {
    ...CommonProperties.borderRadius3,
    ...CommonProperties.px5,
    ...CommonProperties.py2,
    justifyContent: 'center',
    ...CommonProperties.ml3,
  },
  itemSelected: {
    backgroundColor: '#efefef',
  },
  itemUnselected: {
    backgroundColor: 'transparent',
    borderWidth: 0.5,
    borderColor: '#efefef',
  },
});

export default EventSelector;
